<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="6" class="logoBox">
        <div class="box">
          <img class="logoImg" src="../assets/logo.png" />
          <div class="title">Data Report Portal</div>
        </div>
      </el-col>
      <el-col :span="18" class="menu">
        <div
          class="menuItem"
          v-for="(item, index) in routersList"
          :key="index"
          @click="clickMenuItem(index, item)"
        >
          <!-- <a >
						{{ item.name }}
					</a> -->
					<!-- :style="{ 'margin-left': index == 0 ? '0' : '95px' }" -->
          <div
            class="item active"
            v-show="currentIndex == index"
            v-if="item.id < 5"
          >
            <img
              class="icon-report"
              v-if="item.name === '报告中心'"
              src="../assets/icon_report_active.png"
              alt=""
            />
            <img
              class="icon-admin"
              v-if="item.name === 'Admin'"
              src="../assets/icon_admin_active.png"
              alt=""
            />
            <img
              class="icon-upload"
              v-if="item.name === '上传中心'"
              src="../assets/icon_upload_active.png"
              alt=""
            />
            <div class="name">{{ item.name }}</div>
          </div>
					<!-- :style="{ 'margin-left': index == 0 ? '0' : '95px' }" -->
          <div
            class="item"
            v-show="currentIndex !== index"
            v-if="item.id < 5"
          >
            <img
              class="icon-report"
              v-if="item.name === '报告中心'"
              src="../assets/icon_report.png"
              alt=""
            />
            <img
              class="icon-admin"
              v-if="item.name === 'Admin'"
              src="../assets/icon_admin.png"
              alt=""
            />
            <img
              class="icon-upload"
              v-if="item.name === '上传中心'"
              src="../assets/icon_upload.png"
              alt=""
            />
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </el-col>
      <!--
			<el-col :span="14">
				<div class="menu">
					<a :class="$route.meta == item.id ? 'on' : ''" @click="$router.push(item.children[0].path)" v-for="item in routersList" v-if="item.id < 4">
						{{ item.name }}
					</a>
				</div>
			</el-col> -->
			<!-- <el-col :span="2" class="logoText">{{ sysName }}</el-col> -->
      <el-col :span="6" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner">
						<div class="user-info">
							<p>{{ sName }}</p>
							<p>{{ dLastLogin }}</p>
						</div>
						<img src="../assets/user.jpg" />
					</span>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item @click.native="change">Change Password</el-dropdown-item> -->
<!--						<el-dropdown-item @click.native="logout">Logout</el-dropdown-item>-->
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
    </el-col>
    <!-- </el-col> -->
    <el-col
      :span="24"
      class="tabBox"
      v-for="(item, index) in routersList"
      :key="index"
      v-if="$route.meta == item.id && item.id < 5"
    >
      <!-- <div > -->
      <div
        class="tabItem"
        :class="{
          first: index2 == 0,
					last: index2 == item.children.length - 1 && index2 > 0,
					active:index2 === tabIndex
        }"
        v-for="(item2, index2) in item.children"
        :key="index2"
				@click="clickTab(index2,item2)"
      >
        <img class="check" v-show="item2.name === '报告查看' && index2 !== tabIndex" src="../assets/icon_check.png" alt="" />
        <img class="check" v-show="item2.name === '报告查看' && index2 == tabIndex" src="../assets/icon_check_active.png" alt="" />
        <img class="download" v-show="item2.name === '报告下载' && index2 !== tabIndex" src="../assets/icon_download.png" alt="" />
        <img class="download" v-show="item2.name === '报告下载' && index2 == tabIndex" src="../assets/icon_download_active.png" alt="" />
        <div class="name">{{ item2.name }}</div>
      </div>
      <!-- </div> -->

      <!-- <div class="tabItem">
					<div></div>
					<div  class="name">报表下载</div>
				</div> -->
      <!-- <div class="tabItem last">
					<img class="download" src="" alt="">
					<div class="name">报表下载</div>
				</div> -->
    </el-col>

    <!-- <el-col :span="24">
			<div class="menu2" v-for="item in routersList" v-if="$route.meta == item.id && item.id < 4">
				<a @click="$router.push(item2.path)" v-bind:class="routerAClass(item2, index)" v-for="(item2, index) in item.children">
					{{ item2.name }}
				</a>
			</div>
		</el-col> -->
    <el-col :span="24" class="main">
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<el-breadcrumb separator=">" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path" v-if="item.id < 3">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
			<el-dialog title="Change Password" :visible.sync="changeFlag" width="50%">
				<el-form :model="form" ref="form" label-width="160px">
					<el-form-item label="Old Password" prop="oldPwd">
						<el-input v-model="form.oldPwd" type="password" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="New Password" prop="newPwd">
						<el-input v-model="form.newPwd" type="password" placeholder=""></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="changeFlag = false">Cancel</el-button>
					<el-button type="primary" @click="save">Confirm</el-button>
				</span>
			</el-dialog>
		</el-col>
  </el-row>
</template>

<script>
import { loginOut, updateUserPwd } from "../api/api";
import { rolesRouters } from "../routes.js";
export default {
  data() {
    return {
      sysName: " Portal",
      sName: "",
      changeFlag: false,
      form: {
        oldPwd: "",
        newPwd: "",
      },
      dLastLogin: "",
			currentIndex: 0,
			tabIndex:0
    };
  },
  computed: {
    routersList: function () {
      var _arr = [];
      for (var i = 0, len = rolesRouters.length; i < len; i++) {
        if (
          sessionStorage.getItem("sRole").indexOf("Data") > -1 &&
          rolesRouters[i].id == 1
        ) {
          // if(sessionStorage.getItem('sRole').indexOf('Admin') > -1){
          //   rolesRouters[i].children=rolesRouters[i].children1;
          // }
          _arr.push(rolesRouters[i]);
        } else if (
          sessionStorage.getItem("sRole").indexOf("Admin") > -1 &&
          rolesRouters[i].id == 2
        ) {
          _arr.push(rolesRouters[i]);
        } else if (
          sessionStorage.getItem("sRole").indexOf("Upload") > -1 &&
          rolesRouters[i].id == 3
        ) {
          // if(sessionStorage.getItem('sRole').indexOf('Admin') > -1){
          //   rolesRouters[i].children=rolesRouters[i].children1;
          // }
          _arr.push(rolesRouters[i]);
        }else if(rolesRouters[i].id == 4){
          _arr.push(rolesRouters[i]);
        }
      }
      // console.log(sessionStorage.getItem("sRole"));
      // console.log(_arr, "routersList");
      return _arr;
    },
	},
	watch: {
		// routersList:{
		// 	handler(list) {
		// 		console.log(list,1111)
		// 		if (list && list.length) {
		// 			console.log(list[0], 23213213)
		// 			if (list[0].children.length) {
		// 				this.clickTab(0,list[0].children[0])			

		// 			}
		// 		}
		// 	},
		// 	immediate: true
		// }
	},
  methods: {
    clickMenuItem(index, item) {
			this.currentIndex = index;
			this.tabIndex = 0
      this.$router.push(item.children[0].path);
		},
		clickTab(index2, item2) {
			this.tabIndex = index2;
			this.$router.push(item2.path)
		},
    change() {
      this.changeFlag = true;
    },
    save() {
      if (!this.form.oldPwd) {
        this.$message.error("please enter old Password");
        return;
      }
      if (!this.form.newPwd) {
        this.$message.error("please enter new Password");
        return;
      }
      updateUserPwd(this.form).then((res) => {
        this.$refs.form.resetFields();
        this.changeFlag = false;
        this.$message("Change Success");
      });
    },
    logout: function () {
      var _this = this;
      this.$confirm("Confirm Exit?", "Tips", {
        type: "warning",
        customClass: 'customConfimClass'
      })
        .then(() => {
          loginOut({}).then((res) => {
            sessionStorage.clear();
            _this.$router.push("/login");
          });
        })
        .catch(() => {});
    },
    routerAClass(item, index) {
      var data = {};
      data["one_" + item.meta + "_" + (index + 1)] = true;
      data["on"] = this.$route.path == item.path;
      return data;
    },
  },
  mounted() {
    this.sName = sessionStorage.getItem("sName");
    this.dLastLogin = sessionStorage.getItem("dLastLogin");
  },
};
</script>

<style lang="scss">
@import "../scss/reset.scss";
.logoText {
  text-align: center;
  font-size: 22px;
}
.logoImg {
  height: 60px;
  img {
    height: 58px;
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?8ecb0890